// View-scope state shared by the Deliverable and Milestone tabs. Carried
// in the URL as `?scope=all` (default, omittable) / `?scope=contract` /
// `?scope=sow:<id>`. Lenient parser — unknown / malformed values fall back
// to All so a typo or stale link never wedges the surface; the broken-
// link guard in the tab strips the bad param after the SOW list settles.

export type ScopeMode = "all" | "contract" | "sow";

export type ScopeValue =
  | { mode: "all" }
  | { mode: "contract" }
  | { mode: "sow"; sowId: string };

export const ALL_SCOPE: ScopeValue = { mode: "all" };

export function parseScope(raw: string | null): ScopeValue {
  if (!raw) return ALL_SCOPE;
  const value = raw.trim();
  if (value === "" || value === "all") return ALL_SCOPE;
  if (value === "contract") return { mode: "contract" };
  if (value.startsWith("sow:")) {
    const sowId = value.slice("sow:".length).trim();
    if (!sowId) return ALL_SCOPE;
    return { mode: "sow", sowId };
  }
  return ALL_SCOPE;
}

export function serialiseScope(scope: ScopeValue): string | null {
  if (scope.mode === "all") return null;
  if (scope.mode === "contract") return "contract";
  return `sow:${scope.sowId}`;
}

export function scopeEquals(a: ScopeValue, b: ScopeValue): boolean {
  if (a.mode !== b.mode) return false;
  if (a.mode === "sow" && b.mode === "sow") return a.sowId === b.sowId;
  return true;
}
